<footer class="gb_portaMainFoot">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="gb_nameBrand">Plug&Pay</div>
      </div>
      <div class="col-12">
        <ul class="gb_menufoot">
          <li>
            <a href="javascript:void(0);" [routerLink]="['/']" title="Homepage" tabindex="0">Homepage</a>
          </li>
          <!-- [x]: paynow -->
          <li>
            <a href="javascript:void(0);" [routerLink]="['/paynow/pay']" title="{{'paynow-page-title' | translate}}" tabindex="0">{{'paynow-page-title' | translate}}</a>
          </li>
          <li>
            <a href="javascript:void(0);" [routerLink]="['/contacts/info']" title="{{'contacts-page-title' | translate}}" tabindex="0">{{'contacts-page-title' | translate}}</a>
          </li>
        </ul>
      </div>
      <div class="col-12 gb_agency mt-3">
        <p>
          &copy; {{'section.footer.labels.copyright.name' | translate}} <br class="d-block d-md-none" /><span class="d-none d-md-inline">-</span>
          {{'section.footer.labels.copyright.address' | translate}}
          <br class="d-block d-md-none" />{{'section.footer.labels.copyright.cs' | translate}}
          <br class="d-block d-md-none" />{{'section.footer.labels.copyright.pi' | translate}}
        </p>
        <p class="col gb_agencyFoot text-end">
          <!-- [x]: PRIVACY e NOTE LEGALI in popup -->
          <a href="javascript:void(0)" (click)="modalService.showModal('privacy-popup')" tabindex="0" title="{{'generic.buttons.privacy' | translate}}"
            attr.aria-label="{{'generic.buttons.privacy' | translate}}">
            {{"generic.buttons.privacy" | translate}}
          </a>
          &nbsp;&nbsp;
          <a href="javascript:void(0)" (click)="modalService.showModal('legal-popup')" tabindex="0" title="{{'generic.buttons.legal' | translate}}"
            attr.aria-label="{{'generic.buttons.legal' | translate}}">
            {{"generic.buttons.legal" | translate}}
          </a>
          &nbsp;-&nbsp;
          <a href="http://www.greenbubble.it" target="_blank" rel="noopener">digital agency <strong>Greenbubble</strong></a>
        </p>
      </div>
    </div>
  </div>
</footer>

<!-- [x]: privacy -->
<div class="gb-popup d-none" data-tipo="privacy-popup" aria-labelledby="alert-privacy-popup" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header pb-0">
      <span class="gb_h2_pp" [innerHTML]="'privacy-page-title' | translate | safeHtml"></span>
      <button type="button" title="{{ 'footer-modale-chiudi' | translate }}"
        attr.aria-label="{{ 'footer-modale-chiudi' | translate }}" tabindex="0" class="gb-close-pp gb-button-reset"
        tabindex="0">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ 'footer-modale-chiudi' | translate }}</em>
      </button>
    </div>
    <div class="gb-popup-main">
      <footer-area-privacy></footer-area-privacy>
    </div>
  </div>
</div>

<!-- [x]: legal -->
<div class="gb-popup d-none" data-tipo="legal-popup" aria-labelledby="alert-legal-popup" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header pb-0">
      <span class="gb_h2_pp">{{'legal-page-title' | translate}}</span>
      <button type="button" title="{{ 'footer-modale-chiudi' | translate }}"
        attr.aria-label="{{ 'footer-modale-chiudi' | translate }}" tabindex="0" class="gb-close-pp gb-button-reset"
        tabindex="0">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ 'footer-modale-chiudi' | translate }}</em>
      </button>
    </div>
    <div class="gb-popup-main">
      <footer-area-notelegali></footer-area-notelegali>
    </div>
  </div>
</div>

<button type="button" title="{{'generic.labels.onTop' | translate}}" attr.aria-label="{{'generic.labels.onTop' | translate}}" aria-hidden="true" tabindex="-1" class="gb-button-reset"
  id="gb_scrolltop">
  <span>
    <svg viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z">
      </path>
    </svg>
    <em class="gb-hidden-visually gb-speak">{{'generic.labels.onTop' | translate}}</em>
  </span>
</button>
